/* eslint-disable max-lines-per-function, max-statements */
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import useToggle from "@bluframe/grapple/useToggle";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import useAutosuggestOptions from "hooks/useAutosuggestOptions";
import useUser from "hooks/useUser";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Item from "./Item";
const { vendors: { GET_LABELS, GET_LABEL_BY_ID, SEARCH_VENDORS } } = queries;
const { vendors: { DELETE_LABEL, UPDATE_LABEL } } = mutations;
const usePrepareComponent = () => {
    const [isEditing, toggleIsEditing] = useToggle();
    const history = useHistory();
    const params = useParams();
    const [selectedVendorId, setSelectedVendorId] = useState();
    const { isAdmin, isEditor } = useUser();
    const { data, loading } = useQuery(GET_LABEL_BY_ID, {
        fetchPolicy: "network-only",
        onCompleted: (completedData) => {
            setSelectedVendorId((prev) => prev ?? completedData.getLabelById.vendor.id);
        },
        variables: { id: params.id }
    });
    const [updateLabel, { loading: isSaveLoading }] = useMutation(UPDATE_LABEL, {
        refetchQueries: [{ query: GET_LABEL_BY_ID, variables: { id: params.id } }]
    });
    const [deleteLabel] = useMutation(DELETE_LABEL, {
        refetchQueries: [{ query: GET_LABELS }]
    });
    const [searchVendors, { data: searchVendorsData, loading: searchVendorsLoading }] = useLazyQuery(SEARCH_VENDORS);
    const onCancel = () => {
        toggleIsEditing();
    };
    const onEdit = () => {
        toggleIsEditing();
    };
    const onPublishToggle = () => {
        updateLabel({
            variables: {
                id: params.id,
                labelUpdateInput: { isPublished: !data?.getLabelById.isPublished }
            }
        });
    };
    const onSave = (labelUpdate) => {
        if (!params.id || !labelUpdate.vendorId)
            return;
        updateLabel({
            onCompleted: () => toggleIsEditing(),
            variables: {
                id: params.id,
                labelUpdateInput: {
                    ...labelUpdate,
                    vendorId: labelUpdate.vendorId
                }
            }
        });
    };
    const onDelete = () => {
        if (!params.id) {
            return;
        }
        deleteLabel({
            onCompleted: () => {
                history.push("/vendors/labels");
            },
            variables: { id: params.id }
        });
    };
    const onSelectVendorId = (id) => {
        setSelectedVendorId(id);
    };
    const onGetVendorsSuggestions = ({ inputValue }) => {
        searchVendors({
            variables: {
                searchVendorsInput: { name: inputValue }
            }
        });
    };
    /**
     * Generates options for the vendor autosuggest input.
     */
    const autosuggestVendors = useAutosuggestOptions({
        selected: data?.getLabelById?.vendor,
        suggestions: searchVendorsData?.searchVendors
    });
    return {
        isAdmin,
        isEditing,
        isEditor,
        isSaveLoading,
        isVendorsSuggestionsLoading: searchVendorsLoading,
        item: data?.getLabelById,
        loading,
        onCancel,
        onDelete,
        onEdit,
        onGetVendorsSuggestions,
        onPublishToggle,
        onSave,
        onSelectVendorId,
        selectedVendorId,
        vendors: autosuggestVendors
    };
};
export default prepareComponent(usePrepareComponent)(Item);
